import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { useAppDispatch, useAppSelector } from '../../../state/hooks'
import { auth } from '../../../firebase/config'
import { GiftCardOptions } from '../types'
import CheckoutModal from '../../Checkout/Modals/CheckoutModal'
import OrderConfirmedModal from '../../Checkout/Modals/OrderConfirmedModal'

interface CheckoutProps {
	giftCardData: GiftCardOptions
	taxesAndFees: {
		serviceCharge: number
		serviceChargeGST: number
		serviceChargePST: number
		serviceChargeFeeTax: number
	}
	toggle: any
	navigation: any
}

export default function Checkout({
	giftCardData,
	taxesAndFees,
	toggle,
	navigation,
}: CheckoutProps) {
	const dispatch = useAppDispatch()

	const { loadedData } = useAppSelector(state => state.data)
	const { isTestMode } = useAppSelector(state => state.persisted)
	const { paymentMethods, paymentMethodId } = useAppSelector(state => state.user)
	const { localTimezone } = useAppSelector(state => state.settings)
	const {
		prices,
		useNewPaymentMethod,
		isGuestCheckout,
		loading,
		selectedMethods,
		posExtraData,
		modalTimestamps,
		orderPlaced,
	} = useAppSelector(state => state.checkout)
	const [isOrderConfirmedModalVisible, setIsOrderConfirmedModalVisible] = useState(false)

	const userId = auth.currentUser ? auth.currentUser.uid : ''

	// For placeOrder function
	const data = {
		userId,
		loadedData,
		dispatch,
		useNewPaymentMethod,
		prices,
		isGuestCheckout,
		cardId: paymentMethodId,
		loading,
		navigation: () => {},
		toggleConfirmModal: () => {},
		selectedMethods,
		posExtraData,
		timestampData: modalTimestamps,
		isTestMode,
		localTimezone,
	}

	const pricesArg = {
		discount: 0,
		redeemedGiftCard: 0,
		purchasedGiftCard: 0,
		subTotal: giftCardData.amount / 100,
		deliveryFee: 0,
		serviceCharge: taxesAndFees.serviceCharge / 100,
		serviceChargeGST: taxesAndFees.serviceChargeGST / 100,
		serviceChargePST: taxesAndFees.serviceChargePST / 100,
		serviceFeeTax: taxesAndFees.serviceChargeFeeTax / 100,
		taxes: 0,
		taxesList: [] as any[],
		total: (giftCardData.amount + Object.values(taxesAndFees).reduce((a, b) => a + b, 0)) / 100,
		tip: 0,
		noCodeDiscount: 0,
		organizationDiscount: 0,
		bagFee: 0,
		bagFeeTax: 0,
		subTotalAfterDiscount: 0,
		deliveryFeeOrgCoverage: 0,
		restaurantTaxesList: {} as any,
		restaurantTaxTotals: {} as any,
		itemTaxesList: {} as any,
		itemTaxTotals: {} as any,
	}

	const emptyTipFunctions = {
		tip0: () => null,
		tip5: () => null,
		tip10: () => null,
		tip15: () => null,
		tip18: () => null,
		tip20: () => null,
		setCustomTip: amount => null,
		closeModal: () => null,
	}

	useEffect(() => {
		const dataCopy = { ...data }
		delete dataCopy.loadedData
		delete dataCopy.dispatch
		delete dataCopy.navigation
		delete dataCopy.toggleConfirmModal
		console.log(dataCopy)
	}, [])

	useEffect(() => {
		if (orderPlaced) {
			setIsOrderConfirmedModalVisible(true)
		}
	}, [orderPlaced])

	return (
		<Elements stripe={global.stripePromise}>
			{!orderPlaced ? (
				<CheckoutModal
					toggle={toggle}
					navigation={navigation}
					promoFuncData={null}
					prices={pricesArg}
					goHome={toggle}
					tipFunctions={emptyTipFunctions}
					hideOptions
					useProductCheckout
				/>
			) : (
				<OrderConfirmedModal
					useProductCheckout
					visible={isOrderConfirmedModalVisible}
					setIsOrderConfirmedModalVisible={setIsOrderConfirmedModalVisible}
					goHome={toggle}
				/>
			)}
		</Elements>
	)
}
